import { RouteProp, useNavigation, useRoute } from '@react-navigation/core';
import { StackActions } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { default as React, useEffect } from 'react';
import ActivityIndicatorScreen from '../../components/ActivityIndicatorScreen';
import { useUserContext } from '../../context/UserContext';
import DynamicForm from '../../dynamic-forms/DynamicForm';
import DynamicFormProvider from '../../dynamic-forms/DynamicFormProvider';
import FormDataSource from '../../dynamic-forms/FormDataSource';
import { useGetFormTemplate } from '../../dynamic-forms/hooks/useGetFormTemplate';
import { useRunQuery } from '../../dynamic-forms/hooks/useRunQuery';
import { DrawerParamList } from '../../navigation/DrawerNavigator';

const TestDynamicFormScreen: React.FC = () => {
  const { user } = useUserContext();
  const navigation = useNavigation<StackNavigationProp<DrawerParamList>>();
  const route = useRoute<RouteProp<DrawerParamList, 'TestDynamicFormScreen'>>();
  const statePath = route.params?.path;
  const { formTemplate, getFormTemplate } = useGetFormTemplate('Test Form');
  useEffect(() => getFormTemplate(), [getFormTemplate]);

  // run query to get entity data
  const { queryData, runQueryGetOne } = useRunQuery();
  useEffect(() => {
    if (user?.id) {
      runQueryGetOne({
        queryType: 'select',
        selects: [],
        mainAlias: {
          type: 'from',
          name: 'onboardingForm',
          tablePath: 'onboarding_form'
        },
        wheres: [
          {
            type: 'simple',
            condition: {
              operator: 'equal',
              parameters: ['user_id', user.id.toString()]
            }
          }
        ]
      });
    }
  }, [user, runQueryGetOne]);

  return formTemplate ? (
    <DynamicFormProvider
      entitySchema={formTemplate?.entity}
      formStateNode={formTemplate?.config}
    >
      <FormDataSource formTemplate={formTemplate} formData={queryData}>
        <DynamicForm
          values={queryData}
          statePath={statePath}
          onStatePathChange={(path, stateNode, sectionIndex, sectionCount) => {
            const currentIndex = route.params?.sectionIndex || 0;
            if (sectionIndex < currentIndex) {
              navigation.dispatch(
                StackActions.replace('DrawerNavigator', {
                  screen: 'WelcomeSurveyScreen',
                  params: {
                    path,
                    sectionIndex: sectionIndex - 1,
                    // currentValues: value,
                    backAnimation: true
                  }
                })
              );
            } else if (
              sectionIndex > currentIndex &&
              sectionIndex < sectionCount
            ) {
              navigation.dispatch(
                StackActions.replace('DrawerNavigator', {
                  screen: 'WelcomeSurveyScreen',
                  params: {
                    path,
                    sectionIndex: sectionIndex + 1
                    // currentValues: value
                  }
                })
              );
            } else if (sectionIndex >= sectionCount) {
              navigation.dispatch(
                StackActions.replace('DrawerNavigator', { screen: 'MyChloe' })
              );
            }
          }}
        />
      </FormDataSource>
    </DynamicFormProvider>
  ) : (
    <ActivityIndicatorScreen />
  );
};

export default TestDynamicFormScreen;
